/**
 * @typedef Config
 * @property {string} elementsDomain
 * @property {string[]} marketDomains
 * @property {string} tutsplusDomain
 * @property {string[]} skipNormalizationForAttributes
 */

/**
 * Default configuration for the library.
 * @type {Config}
 */
var defaultConfig = {
  elementsDomain: "elements.envato.com",
  marketDomains: ["themeforest.net", "codecanyon.net", "audiojungle.net", "videohive.net", "graphicriver.net", "photodune.net", "3docean.net", "marketplace.envato.com", "market.envato.com", "envatomarketplaces.com", "market.styleguide.envato.com"],
  tutsplusDomain: "tutsplus.com",
  skipNormalizationForAttributes: ["elements_item_id"] // Deprecated: 'elements_item_id' will be removed from this list in the next major release.
};
module.exports = defaultConfig;